// Admin chunks

const CaseDocuments = () =>
  import(
    /* webpackChunkName: "admin" */
    "@/views/Admin/CaseDocuments/index"
  );

const Userflows = () =>
  import(
    /* webpackChunkName: "admin" */
    "@/views/Admin/Userflows/index"
  );

const OnlineApplication = () =>
  import(
    /* webpackChunkName: "admin" */
    "@/views/Admin/OnlineApplication/index"
  );

const Promocodes = () =>
  import(
    /* webpackChunkName: "admin" */
    "@/views/Admin/Promocodes/index"
  );

const Flows = () =>
  import(
    /* webpackChunkName: "admin" */
    "@/views/Admin/Flows/index"
  );

const adminRoutes = [
  {
    path: "/case_documents",
    name: "case-documents",
    component: CaseDocuments,
    meta: {
      auth: "admin",
      title: "Case documents",
    },
  },

  {
    path: "/userflows",
    name: "Userflows",
    component: Userflows,
    meta: {
      auth: "admin",
      title: "Userflows",
    },
  },

  {
    path: "/online-application",
    name: "Online Application",
    component: OnlineApplication,
    meta: {
      auth: "admin",
      title: "Online application",
    },
  },

  {
    path: "/promo_codes",
    name: "promocodes",
    component: Promocodes,
    meta: {
      auth: "admin",
      title: "Promocodes",
    },
  },

  {
    path: "/flows",
    name: "flows",
    component: Flows,
    meta: {
      auth: "admin",
      title: "Flows",
    },
  },
];

export default adminRoutes;
